import React, { Component } from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import TagV2 from "../tagV2/TagV2";
import { Form, Button, Icon, Select } from "antd";
import { getExplore } from "../../actions/AssetsExploreAction";
import { setSelectedItem, getComments } from "../../actions/CommentAction";
import { getLastUploads } from "../../actions/AssetsLastUploadAction";
import { getFavorites } from "../../actions/AssetsFavoritesAction";
import { getShared } from "../../actions/AssetsShareAction";
import { setUploading, unsetUploading } from "../../actions/ClientAction";
import moment from "moment";
import momentTZ from "moment-timezone";
import Magnifier from "react-magnifier";
import VideoView from "../assets-view/VideoView";
import DocumentView from "../document-view/DocumentView";
import { sendNotification } from "../../utils/index";
import Helper from "../helper/Helper";
import BunkeyApi from "../../api/BunkeyAPI";
import UploadFilesV2 from "./UploadFilesV2";

const { Option } = Select;

export class VersionAsset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      folderId: null,
      tags: [],
      options: [],
      value: false,
      usersSelectedEmail: [],
      usersSelectedId: [],
      copyright: {
        createDate: moment().format("YYYY-MM-DD"),
        dueDate: null
      },
      versionTheme: {
        color: null,
        backgroundColor: null
      },
      fileListCount: 0,
      start: false,
      emptyFields: false,
      isMultiple: false,
      tagProtocol: "",
      showProtocolAlert: null,
      users: [],
      mentionatedUsers: [],
      tagsVersion: []
    };
  }

  componentDidMount() {
    const { itemSelected, theme } = this.props;
    this.setState(
      {
        folderId: itemSelected.document.parents.slice(-1),
        users: this.handleGetUsers(itemSelected),
        versionTheme:
          theme === "dark"
            ? {
                color: "#909090",
                backgroundColor: "#202022"
              }
            : {
                color: null,
                backgroundColor: "#fff"
              }
      },
      () => this.handleGetTagNewVersion(itemSelected.document._id)
    );
  }

  componentDidUpdate(prevProps) {
    const { folderselect, itemSelected, authUser } = this.props;
    const { start } = this.state;
    const { options } = this.state;

    const data = this.handleGetUsers(itemSelected);
    if (prevProps.data !== data && data.length > 0 && options.length === 0) {
      this.setState({
        options: data
          .filter(r => r._id !== authUser._id)
          .map((r, k) => (
            <Option
              key={k}
              name={r.name}
              email={r.email}
              value={r.name + r.email}
              uid={r._id}
            >
              {" "}
              {`${r.name} (${r.email})`}
            </Option>
          ))
      });
    }

    if (!start && prevProps.folderselect !== folderselect) {
      this.setState({
        folderId: folderselect
      });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    const { isUploading } = this.props;
    return !isUploading;
  }
  /**
   * @param { Object } itemSelected
   * @name handleGetUsers
   */
  handleGetUsers = itemSelected => {
    let users = [];

    if (itemSelected && itemSelected.adminUsers) {
      itemSelected.adminUsers.forEach(item => {
        users.push({
          _id: item._id,
          name: item.name,
          email: item.email
        });
      });
    }

    if (itemSelected && itemSelected.operatorUsers) {
      itemSelected.operatorUsers.forEach(item => {
        if (!users.find(r => r._id === item.id)) {
          users.push({
            _id: item._id,
            name: item.name,
            email: item.email
          });
        }
      });
    }
    return users;
  };

  handleFolderSelect = folderId => {
    this.setState({ folderId });
  };

  handleOnChangeUser = (item, list) => {
    this.setState({
      usersSelectedEmail: item,
      usersSelectedId: list.map(r => r.props.uid),
      mentionatedUsers: list.map(r => {
        return { _id: r.props.uid, email: r.props.email, name: r.props.name };
      }),
      value: true
    });
  };

  handleOnChageAllUsers = value => {
    const { authUser, itemSelected } = this.props;
    const data = this.handleGetUsers(itemSelected);
    const operators = data.filter(r => r._id !== authUser._id);
    this.setState({
      value: true,
      usersSelectedEmail: value ? operators.map(r => r.email) : [],
      usersSelectedId: value ? data.map(r => r._id) : [],
      mentionatedUsers: value ? data : []
    });
  };

  handleGetTagNewVersion = documentId => {
    const { intl } = this.props;
    const tz = momentTZ.tz.guess();
    const tzB64 = window.btoa(tz);
    const { itemsCommentSelected, authUser, itemSelected } = this.props;
    let options = [];
    // --->
    BunkeyApi({
      url: `assetVersion/prepareVersion/${documentId}/tz/${tzB64}?d=${itemSelected}`,
      method: "GET"
    })
      .then(resp => {
        if (!itemSelected.operatorUsers && !itemSelected.adminUsers) {
          const data = this.handleGetUsers(itemsCommentSelected);
          options = data
            .filter(r => r._id !== authUser._id)
            .map((r, k) => (
              <Option
                key={k}
                name={r.name}
                email={r.email}
                value={r.name + r.email}
                uid={r._id}
              >
                {" "}
                {`${r.name} (${r.email})`}
              </Option>
            ));
        }
        this.setState({
          tagsVersion: resp.data,
          options
        });
      })
      .catch(e => {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "error_getting_version_tags" })
        );
      });
  };

  handleTags = objectTag => {
    this.setState({ tags: objectTag.tags });
  };

  handleCopyright = copyright => {
    this.setState({ copyright: copyright.copyright });
  };

  handleUploadMultipartAsset = () => {
    const { fileListCount } = this.state;
    const { intl, folderselect, workclient } = this.props;
    if (fileListCount === 0) {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "select_upload_destination" })
      );
      this.handleStart();
      return;
    }
    this.props.setUploading(workclient, folderselect);
    this.setState({ start: true });
  };

  handleIsDone = (showMessage, close) => {
    const { folderselect, workclient, root, itemSelected } = this.props;

    this.setState(
      {
        start: false,
        emptyFields: true
      },
      () => {
        setTimeout(() => {
          if (close) this.props.handleHideNewVersion();
          this.props.setSelectedItem(itemSelected.document._id);
          this.props.unsetUploading();
          this.props.getLastUploads(workclient, root);
          //
          this.props.getFavorites(workclient, root);
          this.props.getShared(workclient, root);
          //
        }, 500);
        this.props.setUploading(workclient, folderselect);
      }
    );
  };

  handleError = () => {
    this.setState(
      {
        start: false
      },
      () => this.props.unsetUploading()
    );
  };

  handleOnClose = () => {
    this.setState(
      {
        start: false,
        showProtocolAlert: false,
        fileListCount: 0,
        emptyFields: false
      },
      () => {
        this.setState(
          {
            emptyFields: true
          },
          () => {
            setTimeout(() => {
              this.props.handleHideNewVersion();
              this.props.unsetUploading();
            }, 400);
          }
        );
      }
    );
  };

  handleGetFileListTotal = count => {
    this.setState({
      fileListCount: count
    });
  };

  handleStart = () => {
    this.setState({
      start: false
    });
  };
  /**
   * @name handleChange
   */
  handleChange = e => {
    this.setState({
      mentionatedUsers: e.target.value
    });
  };

  render() {
    const { tagsVersion, versionTheme, options } = this.state;
    const {
      intl,
      newColor,
      itemSelected,
      breadCrumbs,
      theme,
      keyCollection,
      from
    } = this.props;
    const {
      tags,
      copyright,
      folderId,
      start,
      emptyFields,
      usersSelectedEmail,
      mentionatedUsers
    } = this.state;

    const metadata = {
      tags: [...tags.concat(tagsVersion)],
      copyright,
      folderId
    };

    return (
      <Form layout="vertical">
        <Form.Item>
          <span style={{ color: "#9b9b9b" }}>{itemSelected.document.name}</span>
          <div>
            {itemSelected.document.type === "image" && (
              <Magnifier
                alt={itemSelected.document.name}
                src={itemSelected.document.lowQualityURL}
                width={250}
              />
            )}
            {itemSelected.document.type === "video" && (
              <VideoView
                url={itemSelected.document.lowQualityURL}
                disableDefaultControls={false}
                autoPlay={false}
              />
            )}
            {itemSelected.document.type === "document" && (
              <DocumentView item={itemSelected.document} from={`middleView`} />
            )}
          </div>
        </Form.Item>
        <div className="path-img" style={{ marginBottom: "20px" }}>
          <span style={{ color: versionTheme.color }}>/</span>
          {breadCrumbs.map((r, k) => (
            <span
              key={k}
              style={{
                fontSize: 13,
                color: versionTheme.color,
                cursor: "auto"
              }}
            >
              {r.name}/
            </span>
          ))}
        </div>
        {/* Tags que se le asignaran al asset */}
        <Form.Item style={{ marginBottom: "10px" }}>
          <span style={{ color: versionTheme.color }}>
            {intl.formatMessage({ id: "add_tags_version" })}
          </span>
          <div>
            {tagsVersion.map((r, k) => (
              <span key={k} className="stylebtn tag-wrapper ReactTags__tag">
                {r}
              </span>
            ))}
          </div>
        </Form.Item>
        <Form.Item style={{ color: versionTheme.color, marginBottom: "10px" }}>
          <span>{intl.formatMessage({ id: "add_tags" })}</span>
          <TagV2 fillTags={tags} handleTags={this.handleTags} />
        </Form.Item>
        {/* Dragger donde se arrastra el asset */}
        <Form.Item style={{ color: versionTheme.color }}>
          {/* Icono con tooltip */}
          <Helper
            title={"helper_title"}
            content={"helper_upload_files"}
            trigger={`click`}
          />
          {/* Upload files v2 */}
          <UploadFilesV2
            theme={theme}
            start={start}
            mentionatedUsers={mentionatedUsers}
            clear={emptyFields}
            itemSelected={itemSelected}
            metadata={metadata}
            isDone={this.handleIsDone}
            fileListTotal={this.handleGetFileListTotal}
            isAssetVersion={true}
            isMultiple={false}
            folderId={folderId}
            keyCollection={keyCollection}
            from={from}
          />
        </Form.Item>
        {/* Usuarios que se pueden notificar */}
        <Form.Item
          label={intl.formatMessage({ id: "notify_to" })}
          className="notifyTo"
        >
          <Select
            dropdownMenuStyle={{ height: 400 }}
            mode="multiple"
            style={{ color: versionTheme.color, width: "100%" }}
            placeholder={intl.formatMessage({ id: "select" })}
            onChange={this.handleOnChangeUser}
            value={usersSelectedEmail}
            // disabled={disableControls}
          >
            {options}
          </Select>
        </Form.Item>
        <Button
          loading={start}
          type="primary"
          style={{ backgroundColor: newColor, borderColor: newColor }}
          onClick={this.handleUploadMultipartAsset}
        >
          <FormattedMessage id="upload_button" />
          <Icon type="cloud-upload" />
        </Button>
        <Button
          type="default"
          onClick={this.handleOnClose}
          style={{
            marginLeft: 10,
            color: newColor,
            backgroundColor: theme.backgroundColor,
            borderColor: newColor
          }}
        >
          {" "}
          <FormattedMessage id="cancel_button" />
          <Icon type="close" />
        </Button>
      </Form>
    );
  }
}

const mapStateToProps = state => {
  return {
    authUser: state.authUser.user,
    folderselect: state.assetsExplore.folderselect,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    workclient: state.client.workclient,
    root: state.client.root,
    breadcrumbs: state.client.breadcrumb,
    itemsCommentSelected: state.comments.itemSelected,
    isUploading: state.client.isUploading
  };
};

const mapDispatchToProps = {
  setUploading,
  unsetUploading,
  getExplore,
  getLastUploads,
  getFavorites,
  getShared,
  setSelectedItem,
  getComments
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(VersionAsset))
);
